import moment from 'moment';

// @vue/component
export default {
  name: 'TimeCounter',

  components: {
  },

  props: {
    timestamp: {
      type: [String],
      default: '',
    },
  },
  data() {
    return {
      timeCounter: 0,
      timer: 0,
    };
  },
  computed: {
    parseToTimestamp() {
      let momentDate = moment().startOf('day')
        .seconds(this.timeCounter)
        .format('H:mm:ss');
      return momentDate.substr(2, 5);
    },
  },
  watch: {
    timestamp(newVal) {
      this.stopCounting();
      if (newVal !== '0' || newVal !== '00:00:00') {
        this.getTimeForBreak();
      }
    },
  },
  async created() {
    this.getTimeForBreak();
  },
  methods: {
    getTimeForBreak() {
      if (this.timestamp === null || this.timestamp.includes('-')) {
        // minusowe powinny byc obslugiwane w bazie/api
        // this.timeCounter = moment('00:00:00', 'HH:mm:ss').diff(moment().startOf('day'), 'seconds');
      } else {
        let timestamp = this.timestamp.slice(0, this.timestamp.indexOf('.'));
        let momentFormat = moment.utc(timestamp, 'H:mm:ss');
        let currentMomentFormat = momentFormat.clone().startOf('day');
        this.timeCounter = momentFormat.diff(currentMomentFormat, 'seconds');
      }
      this.timer = setTimeout(this.startCounting, 1000);
    },
    startCounting() {
      if (this.timeCounter > 0) {
        this.timeCounter -= 1;
        this.timer = setTimeout(this.startCounting, 1000);
      } else {
        // this.stopCounting();
        this.$emit('finishTimer');
      }
    },
    stopCounting() {
      clearTimeout(this.timer);
      this.timer = 0;
    },
  },
};
